import React, { Component } from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import {networkDeviceActions} from "../../../../actions/network-device.actions";
import {Link} from "react-router-dom";
import {Button} from "react-bootstrap";
import {modalActions} from "../../../../actions/modal.actions";
import BreadcrumbExtend from "../../../../components/BreadcrumbExtend";
import {daliEsSystemActions} from "../../../../actions/dali-es-system.actions";
import DaliDeviceInfo from "../_components/DaliDeviceInfo";
import DaliEsSystemSceneTable from "./_components/DaliEsSystemSceneTable";
import DaliEsSystemSceneForm from "./_forms/DaliEsSystemSceneForm";

class DaliEsSystemScenePage extends Component {

    areaId = null;
    groupId = null;
    networkDeviceId = null;


    componentDidMount() {
        const { id, groupId, areaId } = this.props.match.params;
        const { dispatch } = this.props;

        this.networkDeviceId = parseInt(id);
        this.groupId = parseInt(groupId);
        this.areaId = parseInt(areaId);
        dispatch(daliEsSystemActions.getEsSystemGroupById(this.groupId));
        dispatch(daliEsSystemActions.getEsSystemAreaById(this.areaId));
        dispatch(networkDeviceActions.getNetworkDeviceSimpleInfo(this.networkDeviceId));
    }

    openModalCreateHelvarScene = (e) => {
        e.preventDefault();
        const { t, dispatch } = this.props;
        const modalProps = {
            open: true,
            title: t('add_dali-group'),
            component: <DaliEsSystemSceneForm groupId={this.groupId} submitForm={this.handleSubmitCreateHelvarScene}/>
        };
        dispatch(modalActions.showModal({modalProps: modalProps, modalType: 'formModal'}))
    };

    handleSubmitCreateHelvarScene = (model) => {
        const { dispatch } = this.props;
        dispatch(daliEsSystemActions.createEsSystemScene(model));
    };

    render() {
        const { t, simpleDeviceInfo, esSystemAreaItem, esSystemGroupItem } = this.props;

        const breadcrumb = [
            { value: 'network-device', path: '/panel/network-device' },
            { value: simpleDeviceInfo?.label, path: '#' },
            { value: `${t('area')} - ${esSystemAreaItem?.label}`, path: `/panel/network-device/dali/es-system/${this.id}/area` },
            { value: `${t('dali-group')} - ${esSystemGroupItem?.label}`, path: `/panel/network-device/dali/es-system/${this.id}/group/${this.groupId}` },
            { value: `${t('dali-scene')}`, path: "#" },
        ];

        const extendInfo = [
            { key: 'area', value: esSystemAreaItem?.label },
            { key: 'group', value: esSystemGroupItem?.label }
        ];


        return(
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <DaliDeviceInfo networkDeviceInfo={simpleDeviceInfo} title={'dali-scene'} infoElements={extendInfo}/>

                <div className="card">
                    <div className="card-header">
                        <div className="button-group float-right">
                            <Button variant={"success"} onClick={this.openModalCreateHelvarScene}>
                                <i className="fas fa-plus"/> {t('create')}
                            </Button>
                            &nbsp;
                            <Link to={`/panel/network-device/dali/es-system/${simpleDeviceInfo?.id}/groups/${this.areaId}`} className="btn btn-secondary">
                                <i className="fas fa-undo"> </i> {t('back-to-group')}
                            </Link> &nbsp;
                        </div>
                    </div>
                    <div className="card-body">
                        <DaliEsSystemSceneTable list={esSystemGroupItem?.daliEsSystemScenes} />
                    </div>
                </div>

            </div>
        )
    }
}
const mapStateToProps = (state) => {
    const { simpleDeviceInfo} = state.networkDeviceReducer;
    const { esSystemGroupItem, esSystemAreaItem } = state.daliEsSystemReducer;
    return {
        simpleDeviceInfo, esSystemAreaItem, esSystemGroupItem
    }
};
export default withNamespaces()(connect(mapStateToProps)(DaliEsSystemScenePage));
